/* assets/hide-rewards-11008.js */
(function () {
  const HANDLE_PART = '/products/compresse-chaude-froide-pelvienne';
  const VARIANT_ID  = '51758662189340';

  const getRoot = () => (window.upcartDocumentOrShadowRoot || document);

  function cartHasTargetProduct(root) {
    if (!root) return false;
    if (root.querySelector(`.upcart-product-title-link[href*="${HANDLE_PART}"]`)) return true;
    if (root.querySelector(`a[href*="variant=${VARIANT_ID}"]`)) return true;
    if (root.querySelector(`[id^="${VARIANT_ID}:"]`)) return true;
    return false;
  }

  function setRewardsHidden(root, hide) {
    if (!root) return;
    root.querySelectorAll('.upcart-rewards').forEach((el) => {
      if (hide) {
        el.setAttribute('data-hidden-by-theme', '1');
        el.style.setProperty('display', 'none', 'important');
      } else if (el.getAttribute('data-hidden-by-theme') === '1') {
        el.style.removeProperty('display');
        el.removeAttribute('data-hidden-by-theme');
      }
    });
  }

  function apply() {
    const root = getRoot();
    setRewardsHidden(root, cartHasTargetProduct(root));
  }

  apply();

  const observers = [];

  function observeTarget(target) {
    if (!target) return;
    const mo = new MutationObserver(apply);
    mo.observe(target, { childList: true, subtree: true });
    observers.push(mo);
  }

  observeTarget(document);

  const waitForRoot = setInterval(() => {
    const r = getRoot();
    if (r && r !== document) {
      observeTarget(r);
      clearInterval(waitForRoot);
      apply();
    }
  }, 200);

  function chain(oldFn, extra) {
    if (typeof oldFn === 'function') {
      return function () { try { oldFn.apply(this, arguments); } finally { extra(); } };
    }
    return extra;
  }
  try { window.upcartOnCartLoaded = chain(window.upcartOnCartLoaded, apply); } catch {}
  try { window.upcartOnCartOpened = chain(window.upcartOnCartOpened, apply); } catch {}

  setInterval(apply, 800);
})();
